/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import { Target, Zap, Eye, Cpu, Users, Award, Languages, Building2, HeartPulse, Scale, Banknote, ShoppingCart, Megaphone, Factory, CheckBadge, MonitorSmartphone, Briefcase, Gamepad2, Leaf } from 'lucide-react';
// Import obrazka zespołu
import teamIllustration from '../assets/images/team-illustration.png';
import './AboutPage.css';

// Placeholder ZESPOŁU został usunięty

const ClientDescriptionPlaceholder = ({ description }) => (
    <div className="client-description-placeholder">{description}</div>
);

function AboutPage() {
    const [headerRef, isHeaderVisible] = useIntersectionObserver();
    const [missionRef, isMissionVisible] = useIntersectionObserver();
    const [valuesRef, isValuesVisible] = useIntersectionObserver();
    const [teamRef, isTeamVisible] = useIntersectionObserver();
    const [industriesRef, isIndustriesVisible] = useIntersectionObserver();
    const [trustedRef, isTrustedVisible] = useIntersectionObserver();
    const [ctaRef, isCtaVisible] = useIntersectionObserver();

    return (
        <>
            <section ref={headerRef} className={`page-header-section section-bg-white animate-on-scroll ${isHeaderVisible ? 'is-visible' : ''}`}>
                <div className="container text-center">
                    <h1>Poznaj Zespół Lingland</h1>
                    <p className="subtitle">Jesteśmy pasjonatami języków i technologii, którzy wierzą w siłę precyzyjnej komunikacji ponad granicami.</p>
                </div>
            </section>

            <section ref={missionRef} className={`mission-section section-bg-light-gray animate-on-scroll ${isMissionVisible ? 'is-visible' : ''}`}>
                <div className="container mission-container">
                    <div className="mission-text">
                        <h2>Nasza Misja: Przełamywanie Barier Językowych</h2>
                        <p>Lingland powstało z potrzeby stworzenia nowoczesnego biura tłumaczeń, które łączy lingwistyczną doskonałość z technologiczną innowacją. Naszym celem jest nie tylko tłumaczenie słów, ale przede wszystkim budowanie mostów zrozumienia między kulturami i rynkami.</p>
                        <p>Wierzymy, że wysokiej jakości tłumaczenie to klucz do globalnego sukcesu – niezależnie od tego, czy wprowadzasz produkt na nowy rynek, komunikujesz się z międzynarodowymi partnerami, czy dzielisz się wiedzą ze światem.</p>
                    </div>
                    <div className="mission-visual">
                         <Target size={150} strokeWidth={1} color="var(--color-accent)" opacity={0.8}/>
                    </div>
                </div>
            </section>

            <section ref={valuesRef} className={`values-section section-bg-white animate-on-scroll ${isValuesVisible ? 'is-visible' : ''}`}>
                <div className="container">
                    <h2 className="text-center">Nasze Wartości</h2>
                    <div className="values-grid">
                        <div className="value-item">
                            <Zap size={48} strokeWidth={1.5} color="var(--color-accent)"/>
                            <h4>Jakość bez Kompromisów</h4>
                            <p>Stawiamy na precyzję, dokładność i wierność przekazu, wspierane przez rygorystyczne procesy kontroli jakości.</p>
                        </div>
                        <div className="value-item">
                            <Eye size={48} strokeWidth={1.5} color="var(--color-accent)"/>
                            <h4>Transparentność</h4>
                            <p>Jasne zasady współpracy, przejrzysty cennik i stała komunikacja na każdym etapie realizacji zlecenia.</p>
                        </div>
                        <div className="value-item">
                            <Cpu size={48} strokeWidth={1.5} color="var(--color-accent)"/>
                            <h4>Nowoczesność i Technologia</h4>
                            <p>Wykorzystujemy najnowsze narzędzia CAT i rozwiązania technologiczne, aby optymalizować procesy i zapewniać spójność.</p>
                        </div>
                         <div className="value-item">
                            <Users size={48} strokeWidth={1.5} color="var(--color-accent)"/>
                            <h4>Partnerstwo i Zaufanie</h4>
                            <p>Budujemy długoterminowe relacje z klientami, stając się ich zaufanym partnerem w komunikacji międzynarodowej.</p>
                        </div>
                    </div>
                </div>
            </section>

             <section ref={teamRef} className={`team-section section-bg-light-gray animate-on-scroll ${isTeamVisible ? 'is-visible' : ''}`}>
                <div className="container team-container">
                     <div className="team-visual">
                        {/* Zastosowanie obrazka */}
                        <img src={teamIllustration} alt="Zespół Lingland" className="team-illustration"/>
                    </div>
                    <div className="team-text">
                        <h2>Doświadczony Zespół Ekspertów</h2>
                        <p>Nasz zespół składa się z wykwalifikowanych tłumaczy, redaktorów i project managerów z wieloletnim doświadczeniem w różnorodnych dziedzinach. Współpracujemy z setkami lingwistów na całym świecie, obsługując ponad 50 języków.</p>
                        <p>Każdy członek naszego zespołu to nie tylko ekspert językowy, ale także specjalista w konkretnej branży, co gwarantuje merytoryczną poprawność i zrozumienie kontekstu Twoich materiałów.</p>
                        <div className="team-highlights">
                           <div><Award size={24}/><span>Doświadczeni Lingwiści</span></div>
                           <div><Languages size={24}/><span>Ponad 50 Języków</span></div>
                           <div><Briefcase size={24}/><span>Ekspertyza Branżowa</span></div>
                        </div>
                    </div>
                </div>
            </section>

             <section ref={industriesRef} className={`industries-section section-bg-white animate-on-scroll ${isIndustriesVisible ? 'is-visible' : ''}`}>
                <div className="container text-center">
                    <h2>Specjalizujemy się w Branżach</h2>
                     <p className="subtitle">Rozumiemy unikalne potrzeby i terminologię kluczowych sektorów rynku.</p>
                     <div className="industries-grid-about">
                        <div className="industry-item"><MonitorSmartphone size={32} strokeWidth={1.5}/><span>IT i Nowe Technologie</span></div>
                        <div className="industry-item"><Scale size={32} strokeWidth={1.5}/><span>Prawo i Finanse</span></div>
                        <div className="industry-item"><HeartPulse size={32} strokeWidth={1.5}/><span>Medycyna i Farmacja</span></div>
                        <div className="industry-item"><Megaphone size={32} strokeWidth={1.5}/><span>Marketing i Reklama</span></div>
                        <div className="industry-item"><ShoppingCart size={32} strokeWidth={1.5}/><span>E-commerce</span></div>
                        <div className="industry-item"><Factory size={32} strokeWidth={1.5}/><span>Przemysł i Technika</span></div>
                        <div className="industry-item"><Gamepad2 size={32} strokeWidth={1.5}/><span>Gry Komputerowe</span></div>
                        <div className="industry-item"><Leaf size={32} strokeWidth={1.5}/><span>Ekologia i Energia</span></div>
                    </div>
                </div>
            </section>

             <section ref={trustedRef} className={`trusted-by-section section-bg-light-gray animate-on-scroll ${isTrustedVisible ? 'is-visible' : ''}`}>
                 <div className="container text-center">
                     <h2>Zaufali Nam</h2>
                     <p className="subtitle">Jesteśmy dumni ze współpracy z liderami w swoich branżach.</p>
                     <div className="clients-grid">
                         <ClientDescriptionPlaceholder description="Międzynarodowa Korporacja Technologiczna"/>
                         <ClientDescriptionPlaceholder description="Wiodąca Kancelaria Prawna"/>
                         <ClientDescriptionPlaceholder description="Innowacyjny Start-up Medyczny"/>
                         <ClientDescriptionPlaceholder description="Duża Platforma E-commerce"/>
                         <ClientDescriptionPlaceholder description="Globalna Agencja Marketingowa"/>
                         <ClientDescriptionPlaceholder description="Producent Maszyn Przemysłowych"/>
                     </div>
                 </div>
             </section>

             <section ref={ctaRef} className={`cta-about-end section-bg-white animate-on-scroll ${isCtaVisible ? 'is-visible' : ''}`}>
                 <div className="container text-center">
                     <h2>Gotów, by Dołączyć do Grona Zadowolonych Klientów?</h2>
                     <p className="subtitle">Niezależnie od skali projektu, jesteśmy gotowi sprostać Twoim oczekiwaniom.</p>
                     <Link to="/wycena" className="button-outline-primary">
                         Poproś o Wycenę
                     </Link>
                 </div>
             </section>
        </>
    );
}

export default AboutPage;